import { create } from 'zustand';

/**
 * pageMetaStore — metadatos transitorios de la página activa que el Layout
 * renderiza junto al título (ej. "Actualizado: HH:MM:SS"). Cada página los
 * setea cuando carga datos y los limpia al desmontarse.
 *
 * Uso:
 *   const setLastUpdated = usePageMetaStore(s => s.setLastUpdated);
 *   const clearPageMeta  = usePageMetaStore(s => s.clear);
 *
 *   // al traer datos:
 *   setLastUpdated(new Date());
 *
 *   // cleanup (importante para no arrastrar la hora a otra pantalla):
 *   useEffect(() => () => clearPageMeta(), [clearPageMeta]);
 */
const usePageMetaStore = create((set) => ({
  lastUpdated: null,
  setLastUpdated: (date) => set({ lastUpdated: date || null }),
  clear: () => set({ lastUpdated: null })
}));

export default usePageMetaStore;
